import React from 'react';
import { BonusSection } from '../components/BonusSection';
import { FAQSection } from '../components/FAQSection';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { HeroSection } from '../components/HeroSection';
import { ModulesSection } from '../components/ModulesSection';
import { PricingSection } from '../components/PricingSection';
import { ProblemSection } from '../components/ProblemSection';
import { ProofSection } from '../components/ProofSection';
import { PurchasePopup } from '../components/PurchasePopup';
import { SystemSection } from '../components/SystemSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { UrgencySection } from '../components/UrgencySection';
import { useScreenInit } from '../useScreenInit';
export function LandingPage() {
  useScreenInit();
  return <main className="min-h-screen w-full overflow-hidden bg-white" data-id="element-250">
      <HeroSection data-id="element-251" />
      <ProofSection data-id="element-252" />
      <ProblemSection data-id="element-253" />
      <SystemSection data-id="element-254" />
      <ModulesSection data-id="element-255" />
      <BonusSection data-id="element-256" />
      <UrgencySection data-id="element-257" />
      <PricingSection data-id="element-258" />
      <TestimonialsSection data-id="element-259" />
      <GuaranteeSection data-id="element-260" />
      <FAQSection data-id="element-261" />
      <FinalCTA data-id="element-262" />
      <Footer data-id="element-263" />
      <PurchasePopup data-id="element-264" />
    </main>;
}